export default __webpack_public_path__ + "static/coaching-app-393339c40d7e86ae2d8a20637a322a86.png";